var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebdesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 71.68 71.68",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.336,42.336c-1.792,1.793-2.24,3.809,0.446,6.496c2.688,2.688,7.394,1.119,7.616,4.928 c2.688-4.256,1.119-8.512-1.566-11.199C46.145,39.871,43.904,40.545,42.336,42.336z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.111,41.664c0.896-0.896,1.121-2.24,0.226-3.359c-1.345-2.017-20.16-18.369-20.16-18.369 c-0.896-0.896-2.24-1.119-2.688-0.447c-0.447,0.447-0.224,1.791,0.448,2.688c0,0,12.768,15.681,18.368,20.161 c1.12,0.672,2.465,0.672,3.36-0.227L42.111,41.664z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.96,0H6.72C2.911,0,0,2.912,0,6.72v58.239c0,3.809,2.911,6.721,6.72,6.721h58.24c3.808,0,6.72-2.912,6.72-6.721V6.72 C71.68,2.912,68.768,0,64.96,0z M25.088,4.704c1.344,0,2.688,1.12,2.688,2.688c0,1.567-1.12,2.688-2.688,2.688 c-1.345,0-2.688-1.12-2.688-2.688S23.52,4.704,25.088,4.704z M17.472,4.704c1.344,0,2.688,1.12,2.688,2.688 c0,1.567-1.119,2.688-2.688,2.688c-1.569,0-2.688-1.12-2.688-2.688C14.783,5.824,16.128,4.704,17.472,4.704z M10.08,4.704 c1.344,0,2.688,1.12,2.688,2.688c0,1.567-1.12,2.688-2.688,2.688S7.392,8.96,7.392,7.392S8.736,4.704,10.08,4.704z M63.84,59.359 c0,2.466-2.017,4.48-4.48,4.48H12.32c-2.464,0-4.479-2.016-4.479-4.48V19.04c0-2.464,2.016-4.479,4.479-4.479h19.04 c4.256,0,4.48,0,4.48-2.24c0-2.912,2.016-4.479,4.479-4.479h19.041c2.465,0,4.479,2.016,4.479,4.479L63.84,59.359L63.84,59.359z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebdesign);
export default __webpack_public_path__ + "static/media/web design.db7cac24e40eea3073e4bb41293c55ba.svg";
export { ForwardRef as ReactComponent };